"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function ToolbarBatch(props) {
  return null;
}

exports.default = ToolbarBatch;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table-area@0.0.19@@alicd/crui-table-area/lib/ToolbarBatch.js
// module id = 283
// module chunks = 0